import { FEET_VALUE } from './imperial-values.helpers';

export function metersToFeets(meters: number): number {
  return Math.round(meters * FEET_VALUE);
}
